// extracted by mini-css-extract-plugin
module.exports = {"logos":"logos_logos__GSBc7","logo-slide":"logos_logo-slide___067K","slide":"logos_slide__m3DrX","wrapper":"logos_wrapper__kmpiq","img":"logos_img__6uPw_"};